const Decimal = require('decimal.js').default;

function helper(decimal) {
  const roundedToThreeDigits = decimal.toNumber();
  const roundedToThreeDigitsDecimal = new Decimal(roundedToThreeDigits);
  const splitOnDecimal = roundedToThreeDigits.toString().split('.');
  if (splitOnDecimal.length < 2) {
    return roundedToThreeDigitsDecimal.toDecimalPlaces(2, 0).toNumber();
  }
  const decimals = splitOnDecimal[1];
  if (decimals[2] < 5) {
    const roundedDownToTwoDigits = roundedToThreeDigitsDecimal
      .toDecimalPlaces(2, Decimal.ROUND_DOWN)
      .toNumber();

    return roundedDownToTwoDigits;
  }
  const roundedUpToTwoDigits = roundedToThreeDigitsDecimal
    .toDecimalPlaces(2, 0)
    .toNumber();

  return roundedUpToTwoDigits;
}

export default function roundUpOrDown(decimal) {
  // TODO: only accept decimal types. merge helper function in here
  if (!decimal) return 0;
  const num = new Decimal(decimal);
  return helper(num);
}
